module.exports = "<div>{{getTranslationForLicensePanel 'framework.generic.anErrorOccured'}}</div>";